import { Box, Grid, IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import DashboardStatCard from "../../components/DashboardStatCard";
import DashboardInsightsCard from "../../components/DashboardInsightsCard";
import TopSegmentsCard from "../../components/TopSegmentsCard";
import TopCampaignsCard from "../../components/TopCampaignsCard";
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import TouchAppOutlinedIcon from '@mui/icons-material/TouchAppOutlined';
import ChatIcon from '@mui/icons-material/Chat';

const Dashboard = () => {
  const navigate = useNavigate();

  const handleChatClick = () => {
    navigate('/accueil');
  };

  return (
    <Box m={{ xs: 1, md: 2 }}>
      <Header 
        title="Dashboard" 
        subtitle="Vue d'ensemble de vos performances marketing"
        action={
          <Tooltip title="Accéder au Chat">
            <IconButton
              onClick={handleChatClick}
              sx={{
                backgroundColor: '#1976d2',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#1565c0',
                },
                width: 48,
                height: 48,
              }}
            >
              <ChatIcon />
            </IconButton>
          </Tooltip>
        }
      />
      <Grid container spacing={3}>
        {/* LIGNE 1 : STATISTIQUES CLÉS */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardStatCard
            title="Nouveaux Contacts (30j)"
            value="1,250"
            variation="+5.2%"
            icon={<PeopleAltOutlinedIcon sx={{ fontSize: '2.5rem' }} />}
            color="#1976d2"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DashboardStatCard
            title="Taux d'Ouverture Moyen"
            value="22.5%"
            variation="-0.8%"
            icon={<MarkEmailReadOutlinedIcon sx={{ fontSize: '2.5rem' }} />}
            color="#ff9800"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <DashboardStatCard
            title="Taux de Clic Moyen"
            value="3.1%"
            variation="+0.2%"
            icon={<TouchAppOutlinedIcon sx={{ fontSize: '2.5rem' }} />}
            color="#43a047"
          />
        </Grid>

        {/* LIGNE 2 : ANALYSES DÉTAILLÉES */}
        <Grid item xs={12} lg={4}>
          <DashboardInsightsCard />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TopSegmentsCard />
        </Grid>
        <Grid item xs={12} lg={4}>
          <TopCampaignsCard />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
